import type { ReactNode } from 'react';

import { Trans } from '@lingui/react/macro';

// Style constants
const CARD_STYLES =
  'vai-bg-white vai-rounded-lg vai-border vai-border-gray-200 vai-overflow-hidden';
const CONTENT_STYLES = 'vai-p-6';

interface SectionCardWithHeaderProps {
  title: string;
  children: ReactNode;
  className?: string;
  /** Optional content to render on the right side of the header (e.g. toggle buttons). */
  headerRight?: ReactNode;
  /** Optional subtitle (e.g. network name) shown after the title in muted style. */
  subtitle?: string;
}

export const SectionCardWithHeader = ({
  title,
  children,
  className = '',
  headerRight,
  subtitle,
}: SectionCardWithHeaderProps) => {
  return (
    <div className={`${CARD_STYLES} ${className}`}>
      {/* Header with Title and optional right content */}
      <div className="vai-p-4">
        <div className="vai-flex vai-items-center vai-justify-between">
          <h2 className="vai-text-2xl vai-font-bold vai-leading-tight vai-text-gray-900">
            {title}
            {subtitle && (
              <span className="vai-ml-2 vai-text-lg vai-font-normal vai-text-gray-500">
                — {subtitle}
              </span>
            )}
          </h2>
          {headerRight}
        </div>
      </div>

      {/* Bottom Border - Full Width */}
      <div className="vai-h-px vai-bg-gray-200"></div>

      {/* Content Area */}
      <div className={CONTENT_STYLES}>{children}</div>
    </div>
  );
};
